import React, { useState, useEffect } from 'react';
import { Tabla } from './Tabla';
import ProvinciaTabla from '../types/ProvinciaTabla';
import SeleccionarPais from './SeleccionarPais';
import ObtenerProvincias from '../functions/ObtenerProvincias';
import ObtenerPais from '../functions/ObtenerPais';
import PaisSeleccionar from '../types/PaisSeleccionar';

interface ListarProvinciasProps {
    defaultItemsPerPage?: number;
    handleEdit: (provincia: ProvinciaTabla) => void;
    handleDelete: (provincia: ProvinciaTabla) => void;
    handleAdd: () => void;
    pais: PaisSeleccionar;
}

export const ListarProvincias: React.FC<ListarProvinciasProps> = ({ defaultItemsPerPage = 15, handleEdit, handleDelete, handleAdd, pais, }) => {
  
  const [provincias, setProvincias] = useState<ProvinciaTabla[]>([]);
  const [nombrePais, setNombrePais] = useState<string>('');

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [itemsPerPage, setItemsPerPage] = useState(defaultItemsPerPage);

  const cargarPais = async (idPais: number) => {
    const respuesta = await ObtenerPais(idPais);
    return respuesta;
  };

  const handleMostrarCredencial = (provincia: ProvinciaTabla) => {
    console.log('Mostrar credencial', provincia);
  };

  const handleUbication = (provincia: ProvinciaTabla) => {
    console.log('Mostrar ubicacion', provincia);
  };
  
  useEffect(() => {
    const fetchProvincias = async () => {
      try {
        const paisData = await ObtenerPais(pais.id);
        const data = await ObtenerProvincias(paisData.pais[0].id);
        
        const provinciasRecuperadas: ProvinciaTabla[] = [];

        for (const provincia of data.provincias) {
          provinciasRecuperadas.push({
            id: provincia.id,
            provincia: provincia.provincia,
            habilitado: provincia.habilitado,
            fch_crea: provincia.fch_crea,
            fch_modi: provincia.fch_modi,
            dado_baja: provincia.dado_de_baja,
            fch_baja: provincia.fch_baja,
            pais_id: pais.id,
            pais_nombre: pais.name
          });
        };

        setProvincias(provinciasRecuperadas);
        setLoading(false);
      } catch (err) {
        setError('Error al obtener las provincias');
        setLoading(false);
      }
    };

    fetchProvincias();
  
  }, []);

  const columns = [
    { key: 'id', label: 'ID', align: 'center' as const },
    { key: 'provincia', label: 'PROVINCIA', align: 'left' as const },
    { key: 'habilitado', label: 'HABILITADO', align: 'center' as const },
    { key: 'dado_baja', label: 'BAJA', align: 'center' as const },
    { key: 'pais_nombre', label: 'PAIS', align: 'center' as const },
  ];

  const handleEditLocal = (pais: ProvinciaTabla) => {
    handleEdit(pais);
  };

  const handleDeleteLocal = (pais: ProvinciaTabla) => {
    handleDelete(pais);
  };


  if (loading) return <div>Cargando...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="container mx-auto px-2 mt-5">
      <div className="flex flex-row justify-between items-center mb-3">
        <div className="flex flex-col justify-center items-center">
          <h1 className="font-metropolis text-xl font-bold">Provincias cargadas de {pais.name}</h1>
        </div>
        <div className="flex flex-col justify-center items-center">
          <button className="vp-btn-azul-sm" onClick={handleAdd}>Nueva Provincia</button>
        </div>
      </div>
      <Tabla columns={columns} data={provincias} onEdit={handleEditLocal} onDelete={handleDeleteLocal} itemsPerPage={itemsPerPage} onCredencial={handleMostrarCredencial} onUbication={handleUbication} acciones={['editar','eliminar']}/>
    </div>
  );
};